import { configure } from 'mobx';
import queryString from 'query-string';
import { Suspense, useEffect, useMemo } from 'react';
import { RouterProvider } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap-grid.min.css';
import 'bootstrap/dist/css/bootstrap-reboot.min.css';
import './styles/index.css';

import { Layout } from './components/layout/layout';
import { router } from './router/router';
import { AppStore, AppStoreContext } from './store/app';

configure({ enforceActions: 'observed' });

const parsed = queryString.parse(window.location.search);
const { token, hideVideo, name } = parsed;
const isPublicTablePage = /^\/table\//.test(window.location.pathname);

export const App = () => {
  const config = useMemo(
    () => ({
      token: typeof token === 'string' ? token : null,
      hideVideo: Boolean(hideVideo),
      name: typeof name === 'string' ? name : null,
    }),
    [],
  );
  const store = useMemo(() => new AppStore(config), [config]);

  useEffect(() => {
    if (isPublicTablePage) {
      return;
    }
    store.init();
    return () => {
      store.cleanUp();
    };
  }, [store]);
  return (
    <AppStoreContext.Provider value={store}>
      <Suspense fallback={<Layout fetching />}>
        <RouterProvider router={router} />
      </Suspense>
    </AppStoreContext.Provider>
  );
};
